import React, { ChangeEvent } from "react";
import {
  Table, Input, Row, Col, Pagination, Button, Spin, notification, Modal, 
  Popconfirm, Breadcrumb, Upload, Select, FormInstance, Form, Cascader, 
  TreeSelect, Space, Empty,
} from "antd";
import { connect } from "react-redux";
import Column from "antd/lib/table/Column";
import { RootStoreModel } from "../../redux/reducers";
import { Unsubscribe } from "redux";
import { Link, RouteComponentProps } from "react-router-dom";
import { ColumnModel, BasicStateForListModel } from "../models";
import { CancelTokenSource, IsCancel } from "../../axios/axios.core";
import { getTagList } from "@axios/api.account";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import {
  getMacScriptList,
  deleteMacScript,
  addMacScript
} from "../../axios/api.notice";
import { PlusOutlined,CheckCircleFilled,StopFilled } from "@ant-design/icons";

import { TagProps } from "@axios/models";

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  isModalVisible: boolean;
  title: string;
  detail: any;
  status: "Active" | "Disabled";
  search: string;
  id: string;
  appTypeVisible: boolean,
  applyPeople: string
  tags: any[],
  selectId: string,
  remark: string;
  isWatch: boolean;
}

interface propsModel extends RouteComponentProps<any, any, any> {
  orgOptions: treeNode[],
}

const mapStatetoProps = (state: RootStoreModel) => ({
  orgOptions: getOrgsOptionsSelector(state),
});

class MacScriptListPage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      isModalVisible: false,
      title: "",
      detail: "",
      remark: "",
      status: "Active",
      search: "",
      id: "",
      appTypeVisible: false,
      applyPeople: "",
      tags: [],
      selectId: "",
      isWatch: false
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    this.getList();
    this.getTasks();
  }

  componentDidUpdate(prevProps: propsModel) { }

  componentWillUnmount() {
    // this.setState = () => { }
    this.cancelToken.cancel("cancel axios http request");
  }
  getTasks = () => {
    getTagList().then((res) => {

      var dat = this.formatOptions(res)
      console.log("formatOptions", dat);
      this.setState({ tags: dat })
    })
  }
  formatOptions = (tags: TagProps[]) => {
    return tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });
  }
  onSearch = () => {
    this.getList(1);
  };

  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { search } = this.state;
    this.setState({ loading: true });
    getMacScriptList({ pageIndex, pageSize, search }).then((res) => {
      this.setState({
        data: res.dataList,
        loading: false,
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        totalCount: res.totalCount,
      });
    }, () => {
      this.setState({
        loading: false,
      });
    });
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteMacScript(id).then(() => {
      notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
      this.setState({ loading: false });
      this.getList(1);
    });
  };

  onOk = () => {
    const { id, title, detail, status, remark } = this.state;
    if(title == "")
    {
      notification.warning({ message: <Translation>{t => {return t("请输入脚本标题")}}</Translation> });
      return;
    }
    else if(detail == "")
    {
      notification.warning({ message: <Translation>{t => {return t("请输入脚本内容")}}</Translation> });
      return;
    }
    this.setState({ loading: true });
    addMacScript({
      id: id,
      title: title,
      content: detail,
      status: status,
      remark: remark
    }).then(() => {
      notification.success({ message: <Translation>{t => {return t("提交成功")}}</Translation> });
      this.setState({
        id: "",
        loading: false,
        title: "",
        detail: "",
        remark: "",
        isModalVisible: false,
      });
      this.getList(1);
    },()=>{ this.setState({ loading: false }); });
  };

  onEdit = (item: any) => {
    const { id, title, content, status, remark } = item;
    this.setState({
      isModalVisible: true,
      id: id,
      title: title,
      detail: content,
      status: status,
      remark: remark
    });
  };

  onWatch = (item: any) => {
    const { id, title, content, status, remark } = item;
    this.setState({
      isWatch: true,
      detail: content
    });
  };

  onCancel = () => {
    this.setState({
      isModalVisible: false,
      id: "",
      title: "",
      detail: "",
      remark: "",
      status: "Active"
    });
  };

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isModalVisible,
      title,
      detail,
      status,
      search,
      id,
      remark,
      isWatch,
    } = this.state;
    const { orgOptions } = this.props;
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("内容")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("脚本库")}</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/contentdocumentIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("脚本库")}</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={false}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Row className="mb-3">
                      <Col>
                        {t("脚本标题")}:
                        <Input
                          style={{ width: "200px", marginLeft: 10 }}
                          placeholder={t("输入脚本标题搜索")}
                          value={search}
                          onChange={(e) => this.setState({ search: e.target.value })}
                        ></Input>
                      </Col>

                      <Col offset={1}>
                        <Button type="primary" onClick={this.onSearch}>
                          {t("查询")}
                        </Button>
                      </Col>

                    </Row>
                  </div>
                  <div className="borderBox">
                    <Row style={{ marginBottom: 8 }}>
                      <Col className="ms-auto">
                        <Button
                          type="primary"
                          onClick={() => { this.setState({ isModalVisible: true }); }}
                        >
                          <PlusOutlined />
                          {t("添加脚本")}
                        </Button>
                      </Col>
                    </Row>
                    <Table
                      size="middle"
                      loading={loading}
                      dataSource={data}
                      pagination={false}
                      onChange={(pagination) => { }}
                      locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                    >
                      <Column key="title" dataIndex="title" title={t("脚本标题")}></Column>
                      <Column
                        key="content"
                        dataIndex="content"
                        title={t("脚本内容")}
                        render={(v: string, d: any) => (
                          <Button  onClick={() => { this.onWatch(d); }} type="link" size="small">{t("预览")}</Button>
                        )}
                      ></Column>
                      <Column
                        key="status"
                        dataIndex="status"
                        title={t("状态")}
                        render={(v) => (
                          <> 
                            {v=="Active"&&(
                              <span><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                            )}
                            {v=="Disabled"&&(
                              <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                            )}
                          </>
                        )}
                      ></Column>
                      <Column
                        key="updateTime"
                        dataIndex="updateTime"
                        title={t("更新时间")}
                      // render={(v) => v?.slice(10)}
                      ></Column>

                      <Column
                        key="operation"
                        dataIndex="id"
                        title={t("操作")}
                        render={(v: string, d: any) => {
                          return (
                            <Space size={8}>
                              <Button type="link" size="small" onClick={() => { this.onEdit(d); }}>
                                {t("编辑")}
                              </Button>
                              <Popconfirm
                                title={`${t("确认删除脚本")} ${d.title}？`}
                                onConfirm={() => this.onDelete(v)}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                <Button type="link" ghost size="small">
                                  {t("删除")}
                                </Button>
                              </Popconfirm>
                            </Space >
                          );
                        }}
                      ></Column>
                    </Table>
                    <Pagination
                      style={{ textAlign: "right", marginTop: "20px" }}
                      pageSize={pageSize}
                      current={pageIndex}
                      total={totalCount}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                      }
                      onChange={(page, pageSize) => {
                        this.getList(page, pageSize);
                      }}
                      onShowSizeChange={(current, size) => this.getList(current, size)}
                    ></Pagination>
                  </div>
                </Row>
              </Spin>
              <Modal
                maskClosable={false}
                title={id ? t("编辑脚本") : t("添加脚本")}
                destroyOnClose={true}
                confirmLoading={loading}
                open={isModalVisible}
                onOk={() => this.onOk()}
                onCancel={() => this.onCancel()}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Row gutter={24}>
                  <Col span={24}>
                    <label htmlFor=""><span style={{ color: 'red',paddingRight:'2px' }}>*</span>{t("脚本标题")}</label>
                    <div>
                      <Input
                        placeholder={t("脚本标题")}
                        value={title}
                        onChange={(e) => this.setState({ title: e.target.value })}
                      ></Input>
                    </div>
                  </Col>
                  <Col span={24} className="mt-3">
                    <label htmlFor="">{t("脚本备注")}</label>
                    <div>
                      <Input.TextArea
                        value={remark}
                        onChange={(e) => this.setState({ remark: e.target.value })}
                      ></Input.TextArea>
                    </div>
                  </Col>
                  <Col span={24} className="mt-3">
                    <label htmlFor=""><span style={{ color: 'red',paddingRight:'2px' }}>*</span>{t("状态")}</label>
                    <div>
                      <Select
                        value={status}
                        onChange={(v) => this.setState({ status: v as any })}
                      >
                        <Select.Option value="Active"> {t("正常")}</Select.Option>
                        <Select.Option value="Disabled"> {t("禁用")}</Select.Option>
                      </Select>
                    </div>
                  </Col>
                  <Col span={24} className="mt-3">
                    <label htmlFor=""><span style={{ color: 'red',paddingRight:'2px' }}>*</span>{t("脚本内容")}</label>
                    <div>
                      <Input.TextArea
                        value={detail}
                        rows={4}
                        onChange={(e) => this.setState({ detail: e.target.value })}
                      ></Input.TextArea>
                    </div>
                  </Col>
                </Row>
              </Modal>
              <Modal
                maskClosable={false}
                title={t("查看脚本")}
                destroyOnClose={true}
                open={isWatch}
                okText={t("确认")}
                cancelText={t("取消")}
                onOk={() => this.setState({ isWatch : false })}
                onCancel={() => this.setState({ isWatch : false })}
              >
                <Row gutter={24}>
                  <Col span={24} className="mt-3">
                    <label htmlFor=""><span style={{ color: 'red',paddingRight:'2px' }}>*</span>{t("脚本内容")}</label>
                    <div>
                      <Input.TextArea
                        disabled
                        value={detail}
                        rows={4}
                      ></Input.TextArea>
                    </div>
                  </Col>
                </Row>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}

export default connect(mapStatetoProps, {})(MacScriptListPage);
